module.exports = __webpack_public_path__ + "static/media/logo-레인보우브레인@3x.f9f8ceb3.png";